import styled from "@emotion/styled";
import { FaPlay } from "react-icons/fa";

export const VisionSection = styled.div`
//   padding-top: 4rem;
  width: 100%;
  display: flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  padding-top: 60px;
  // @media (max-width: 1024px) {
  //      width: 100%;
  //   }
`;

export const VideoContainer = styled.div`
  margin-top: 1rem;
  display: block;
  text-align: center;
  position: relative;

  @media (min-width: 1024px) {
    // width: 60%;
  }

  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }

  .play-button {
    transition: all 0.3s ease-in-out;
  }

  img {
    width: 100%;
    border-radius: 0.5rem;
    @media (min-width: 1024px) {
      width: 100%;
    }
  }
  > div {
    position: relative;
    display: inline-block;
  }
`;

export const VideoHeading = styled.h2`
    color: rgb(23, 59, 94);
`;


export const VideoImg = styled.img`
  transition: all 0.3s ease-in-out;
`;
export const PlayButton = styled(FaPlay)`
  position: absolute;
  inset: 0;
  color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  svg {
    color: white;
    font-size: 2rem;
  }
`;
export const VideoTitle = styled.p`
  margin-top: 0.5rem;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  color: rgb(23, 59, 94);
`;
